import React from 'react';
import { Loader2 } from 'lucide-react';
import type { SopRun } from '../../../request/sop-synthesizer/sopSynthesizer.api.ts';

interface Props {
  run?: SopRun;
  onCancel?: () => void;
  cancelling?: boolean;
}

const GenerationProgress: React.FC<Props> = ({ run, onCancel, cancelling }) => {
  const pct = Math.max(3, Math.min(100, run?.progress ?? 0));
  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50 p-4" role="status" aria-live="polite">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium text-indigo-900">
          <Loader2 className="h-4 w-4 animate-spin" />
          {run?.message || (run?.status === 'queued' ? 'Waiting for a worker…' : 'Generating your SOP…')}
        </div>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            disabled={cancelling}
            className="rounded-md border border-indigo-300 bg-white px-3 py-1 text-xs text-indigo-800 hover:bg-indigo-100 disabled:opacity-50"
          >
            {cancelling ? 'Cancelling…' : 'Cancel generation'}
          </button>
        )}
      </div>
      <div className="mt-3 h-2 overflow-hidden rounded bg-indigo-100">
        <div className="h-2 bg-indigo-600 transition-all" style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-2 text-xs text-indigo-700">
        This runs in the background and can take several minutes for a long video. You can leave this page; the SOP will be waiting in your list.
      </p>
    </div>
  );
};

export default GenerationProgress;
